import React from "react";
import { observer } from "mobx-react";
import { EmailVerificationViewStore } from "../../store";
import { EmailVerificationViewForm } from "./EmailVerificationViewForm";
import { ErrorDialog } from "../../../../common/controls";

export type EmailVerificationViewProps = {
  emailVerificationViewStore: EmailVerificationViewStore;
};

export const EmailVerificationView: React.FC<EmailVerificationViewProps> =
  observer(({ emailVerificationViewStore }) => {
    return (
      <div>
        <EmailVerificationViewForm
          email={emailVerificationViewStore.emailValue}
          statusOptions={emailVerificationViewStore.getStatusOptions()}
          status={emailVerificationViewStore.statusValue}
          scopeOptions={emailVerificationViewStore.getScopeOptions()}
          scope={emailVerificationViewStore.scopeValue}
          expiresAt={emailVerificationViewStore.expiresAtValue}
          sentAt={emailVerificationViewStore.sentAtValue}
          verifiedAt={emailVerificationViewStore.verifiedAtValue}
          sentCount={emailVerificationViewStore.sentCountValue}
          lastSentAt={emailVerificationViewStore.lastSentAtValue}
          requestedByValue={emailVerificationViewStore.requestedByValue}
          sourceEntity={emailVerificationViewStore.sourceEntityValue}
          sourceRecordId={emailVerificationViewStore.sourceRecordIdValue}
          validationChanges={emailVerificationViewStore.validationChangesValue}
          validationSubmittedAt={
            emailVerificationViewStore.validationSubmittedAtValue
          }
          onPrint={(handlePrint: () => void) =>
            emailVerificationViewStore.printEmailVerification(handlePrint)
          }
          onCancel={() => emailVerificationViewStore.cancelEmailVerification()}
          onEdit={
            emailVerificationViewStore.isEditEnabled
              ? () => emailVerificationViewStore.editEmailVerification()
              : undefined
          }
        />
        <ErrorDialog
          open={emailVerificationViewStore.errorDialogOpened}
          title={emailVerificationViewStore.errorTitle}
          description={emailVerificationViewStore.errorDescription}
          onClose={() => emailVerificationViewStore.closeErrorDialog()}
        />
      </div>
    );
  });
